export default "__VITE_ASSET__Cod4qPZV__"